<template>
  <div class="results fade-in">
    <div v-if="doneLoading" class="results-main">
      <div class="sdgm-back" @click="goBack()" style="position: absolute; left: 15px; top: 5px; z-index: 2; background-color: #fff;">
        <icon class="tiny-svg fill-gray flex" name="arrow-left"></icon>
        <div>{{$t('results.backButtonLabel')}}</div>
      </div>
      <!-- filter bar -->
      <div class="filter-bar">
        <transition name="slide-up">
          <div v-show="showFilters" class="full-width flex-justify-content-center">

            <!-- Vælg resultat / historik -->
            <div class="filter-item">
              <div class="flexbox" style="width: 100%; height: 100%; display: flex; align-items: center;">
                <div @click="changeComponent('resultLatest')" class="select-box" :class="{'selected': activeComponent === 'resultLatest'}">
                  <icon class="medium-svg fill-primary" name="file"></icon>
                  <p>Resultat</p>
                </div>
                <div @click="changeComponent('resultHistory')" class="select-box" :class="{'selected': activeComponent === 'resultHistory'}">
                  <icon class="medium-svg fill-primary" name="history"></icon>
                  <p>Historik</p>
                </div>
              </div>
            </div>

            <!-- vælg fase -->
            <div class="filter-item">
              <phase-wheel class="results-phase-wheel" :multiple="true" :selectAll="true"></phase-wheel>
            </div>

            <!-- Vælg versioner -->
            <div class="filter-item" :class="{'disabled-list': activeComponent === 'resultLatest' && sortedVersions.length > 0}">
              <div class="control">
                <label class="label bold">{{$t('history.versions')}}</label>

                <div v-if="sortedVersions.length > 0" class="select-group">
                  <div @click="setSelectedSortingVersion('all')" class="select-item">
                    <span>{{$t('history.sortAll')}}</span>
                  </div>
                  <div @click="setSelectedSortingVersion('month')" class="select-item">
                    <span>{{$t('history.sortMonth')}}</span>
                  </div>
                  <div @click="setSelectedSortingVersion('quarter')" class="select-item">
                    <span>{{$t('history.sortQuarter')}}</span>
                  </div>
                  <div @click="setSelectedSortingVersion('half')" class="select-item">
                    <span>{{$t('history.sortHalfYear')}}</span>
                  </div>
                  <div @click="setSelectedSortingVersion('year')"  class="select-item">
                    <span>{{$t('history.sortYear')}}</span>
                  </div>
                  <div @click="setSelectedSortingVersion('none')" class="select-item">
                    <span>{{$t('history.none')}}</span>
                  </div>
                </div>

                <div v-if="sortedVersions.length > 0" class="version-list">
                  <div v-for="version in sortedVersions" :key="version.projectVersionId" @click="setSelectedVersion(version)" class="version-item">
                    <div class="version-item-checkbox">
                      <input type="checkbox" class="checkbox" v-model="version.selected" :disabled="activeComponent === 'resultLatest'">
                    </div>
                    <div class="flex-1">
                      <p>{{version.date | formatDate}}</p>
                      <span>{{version.contentJson.comment ? version.contentJson.comment : 'Ingen kommentar'}}</span>
                    </div>
                  </div>
                </div>

                <div v-if="sortedVersions.length === 0">
                  <p>{{$t('history.noVersionsProject')}}</p>
                </div>

              </div>
            </div>

            <!-- seneste version / alle versioner / kun hjul -->
            <div class="filter-item">
              <div class="control">
                <label class="label bold">{{$t('history.listView')}}</label>
                <div class="control">
                  <label class="radio">
                    <input v-model="listViewHistory" type="radio" name="showHistory" value="versionsHistory">
                    {{$t('history.allVersions')}}
                  </label>
                </div>
                <div class="control">
                  <label class="radio">
                    <input v-model="listViewHistory" type="radio" value="wheelsHistory" name="showHistory">
                    {{$t('history.onlyWheels')}}
                  </label>
                </div>
              </div>

              <!-- <div class="bottom-control" style="margin-top: 10px;">
                <div class="control">
                  <label class="checkbox">
                    <input class="checkbox" type="checkbox" v-model="listItemChallenge" style="margin-right: 2px;">
                    Vis defineret udfordring
                  </label>
                </div>
                <div class="control">
                  <label class="checkbox">
                    <input class="checkbox" type="checkbox" v-model="listItemTargets" style="margin-right: 2px;">
                    Vis delmål
                  </label>
                </div>
              </div> -->
            </div>

          </div>
        </transition>
        <div class="history-filter-toggle">
          <div v-if="!showFilters" class="history-filter-toggle-button" @click="toggleFilters()">
            <div>{{$t('history.buttonLabelShowFilters')}}</div>
            <icon class="tiny-svg history-filter-toggle-icon" name="arrow-down"></icon>
          </div>
          <div v-else @click="toggleFilters()" class="history-filter-toggle-button">
            <div>{{$t('history.buttonLabelHideFilters')}}</div>
            <icon class="tiny-svg history-filter-toggle-icon" name="arrow-up"></icon>
          </div>
        </div>
      </div>
      <result-latest v-if="activeComponent === 'resultLatest'" :showFilters="showFilters" :activeComponent="activeComponent" :setScroll="setScrollTime" :listViewHistory="listViewHistory"></result-latest>
      <result-history v-if="activeComponent === 'resultHistory'" :showFilters="showFilters" :activeComponent="activeComponent" :setScroll="setScrollTime" :listViewHistory="listViewHistory"></result-history>
    </div>
    <div v-else :class="{'full-height': !doneLoading}" style="width: 100%;">
      <div class="flex-center" :class="{'full-height': !doneLoading}">
        <icon class="save-spinner-svg flex sdg-spinner" name="sdg-wheel"></icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import phaseWheel from './../shared/phase-wheel/phase-wheel'
import resultLatest from './result-latest'
import resultHistory from './result-history'

export default {
  name: 'results',
  components: {
    phaseWheel,
    'result-latest': resultLatest,
    'result-history': resultHistory
  },
  data () {
    return {
      doneLoading: false,
      activeComponent: 'resultLatest',
      showFilters: false,
      setScrollTime: null,
      selectedSortingVersion: 'all',
      listViewHistory: 'versionsHistory',
      listItemChallenge: true,
      listItemTargets: true
    }
  },
  computed: {
    ...mapGetters({
      createPDF: 'getCreatePDF',
      versions: 'getProjectVersions',
      activePhaseIndex: 'getActivePhaseIndex'
    }),
    sortedVersions () {
      return [...this.versions].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    }
  },
  methods: {
    ...mapActions({
      setActivePageCode: 'setActivePageCode',
      setProjectVersions: 'setProjectVersions',
      setActivePhaseIndexes: 'setActivePhaseIndexes',
      setActivePageViewContext: 'setActivePageViewContext'
    }),
    changeComponent (component) {
      if (component === 'resultHistory') {
        this.setActivePageViewContext('history')
        this.activeComponent = 'resultHistory'
      } else {
        this.setActivePageViewContext('results')
        this.activeComponent = 'resultLatest'
      }
      this.setScrollTime = new Date()
    },
    toggleFilters () {
      this.showFilters = !this.showFilters
    },
    setSelectedSortingVersion (sorting) {
      if (this.activeComponent === 'resultHistory') {
        this.selectedSortingVersion = sorting
        this.setProjectVersions(sorting)
      }
    },
    setSelectedVersion (version) {
      if (this.activeComponent === 'resultHistory') {
        version.selected = !version.selected
      }
    },
    goBack () {
      this.setActivePageCode('tasks')
    }
  },
  async created () {
    this.doneLoading = false
    try {
      this.setActivePageViewContext('results')
      this.setActivePhaseIndexes([this.activePhaseIndex + 1])
      await this.setProjectVersions()
      this.doneLoading = true

      setTimeout(() => {
        this.showFilters = true
      }, 100)
    } catch (err) {
      console.log('error getting versions', err)
    }
  }
}
</script>
